import { useState, useEffect } from 'react';
import { Spin as Hamburger } from 'hamburger-react'
import { NavLink, Link, useLocation } from 'react-router-dom';
import { PiUserDuotone } from 'react-icons/pi';

import SocialList from 'components/SocialList';

import { useAuth } from 'providers/AuthProvider';
import { useWebsite } from 'providers/WebsiteProvider';
import { useConfig } from 'providers/ConfigProvider';

import { getGreetingByTime } from 'utils/GenericUtils';
import { resolveSubsiteMenuPath } from 'utils/SubsiteUtils';

export default function Header(props) {
    const [scroll, setScroll] = useState(false);

    const { userData } = useAuth();
    const { mobileMenuOpen, setMobileMenuOpen } = useWebsite();

    useEffect(() => {
        const onScroll = () => { setScroll(/*window.pageYOffset*/0); };
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <div className={'w-full h-20 px-4 py-5 text-white flex items-center ' + (scroll > 0 ? '' : '') + (props.className || '')}>

            <div className='h-full flex gap-6'>
                <Link to={'/'} className='h-full'><img className='h-full' src='/assets/images/logo/logo_white.svg' alt='Fürge Diák Iskolaszövetkezet' /></Link>
                <SocialList className={'hidden lg:flex transition duration-500 ' + (userData ? 'scale-100' : 'scale-75 opacity-0 pointer-events-none')} />
            </div>

            <div className='relative flex-1 h-full flex'>

                <Menu className={'self-center ' + (userData ? 'opacity-0 pointer-events-none scale-75 ' : '')} />

                <div className={'lg:hidden absolute right-0 transition duration-500 size-10 bg-white/10 ring-4 ring-white/10 rounded-xl transiton active:scale-95 ' + (userData ? 'opacity-0 pointer-events-none scale-75 ' : '')}>
                    <div className='-mt-[4px] -ml-[4px]'><Hamburger size={22} color={'#ffffff'} direction='left' rounded toggled={mobileMenuOpen} toggle={() => setMobileMenuOpen(!mobileMenuOpen)} /></div>
                </div>

                <div className={'absolute right-0 transition duration-500 ' + (userData ? '' : 'opacity-0 pointer-events-none scale-75')}>
                    <ProfileButton />
                </div>

            </div>

        </div>
    );
}

function ProfileButton(props) {
    const { profileOpen, setProfileOpen } = useWebsite();
    const { userData } = useAuth();

    const profilePictureUrl = userData?.photoKey
        ? `${global.backingsEndpoint}photoRepository/getImageBySize?size=ORIGINAL&key=${userData.photoKey}`
        : null;

    return (
        <div className="flex items-center gap-4">
            <div
                className={
                    'hidden lg:flex flex-col gap-1.5 text-right transition duration-500 ' +
                    (profileOpen ? 'opacity-0 pointer-events-none scale-75' : '')
                }
            >
                <div className="font-display font-bold text-lg leading-none text-white">
                    {getGreetingByTime()} {userData?.firstName || "User"}!
                </div>
                <div className="text-[10px] leading-none text-white/50">
                    {userData?.email || "N/A"}
                </div>
            </div>

            <button
                className="size-10 flex items-center justify-center bg-white/10 rounded-xl transition ring-4 ring-white/10 active:scale-95 animated-gradient"
                onClick={() => setProfileOpen(!profileOpen)}
            >
                {profilePictureUrl ? (
                    <img
                        src={profilePictureUrl}
                        alt="Profile"
                        className="rounded-xl w-full h-full object-cover"
                    />
                ) : (
                    <PiUserDuotone className="text-white text-2xl" />
                )}
            </button>
        </div>
    );
}

function Menu(props) {
    const { menuItems } = useConfig();
    const { pathname } = useLocation();

    return (
        <div className={'absolute right-0 hidden lg:flex gap-4 xl:gap-8 transition duration-500 ' + (props.className || '')}>
            {menuItems.map((item) => (
                <MenuItem
                    key={item.label}
                    data={{ ...item, path: resolveSubsiteMenuPath(item.path, pathname) }}
                />
            ))}
        </div>
    );
};

function MenuItem(props) {
    return (
        <NavLink to={props.data.path} className={'text-sm whitespace-nowrap active:scale-95 transition ' + (props.data.className || '')}>
            {props.data.label}
        </NavLink>
    );
}
